import { Component, OnInit } from '@angular/core';
import { Chart, ChartModule } from "angular-highcharts";
import { SampleService } from '../../../services/sample-service/sample.service';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle } from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";

@Component({
  selector: 'app-sample-chart',
  standalone: true,
  imports: [
    ChartModule,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ],
  templateUrl: './sample-chart.component.html',
  styleUrls: ['./sample-chart.component.scss']
})
export class SampleChartComponent implements OnInit {

  duration: string[] = ['Jour', 'Semaine', 'Mois', 'Année'];
  selectedDuration: string = 'jour';

  chartType: ('area' | 'bar' | 'column' | 'spline')[] = ['area', 'bar', 'column', 'spline'];
  selectedChartType: 'area' | 'bar' | 'column' | 'spline' = this.chartType[0];

  lineChart: Chart;
  pieChart: Chart;

  constructor(private sampleService: SampleService) { }

  ngOnInit(): void {
    this.loadSampleData(this.selectedDuration);  // Charger les données dès le début
  }

  loadSampleData(duration: string): void {
    console.log(`🔄 Chargement des données pour la durée : ${duration}`);

    this.sampleService.getChartData(duration).subscribe(data => {
      console.log('✅ Données reçues du backend:', data);

      const dateCountMap: { [key: string]: number } = {};
      const statusData: { [key: string]: number } = {
        'Non Exécuté': 0,
        'En exécution': 0,
        'Terminé': 0
      };

      // Traitement des données pour les deux graphiques
      data.forEach(item => {
        if (item.creationDate && typeof item.count === 'number') {
          const formattedDate = new Date(item.creationDate).toLocaleDateString();
          dateCountMap[formattedDate] = (dateCountMap[formattedDate] || 0) + item.count;
        } else {
          console.warn("⚠️ Donnée ignorée (problème de format) :", item);
        }
      });

      // Mise à jour du graphique linéaire (nombre d'échantillons créés)
      const dates = Object.keys(dateCountMap);
      const counts = Object.values(dateCountMap);

      if (this.lineChart) {
        this.lineChart.ref?.update({
          chart: {
            type: this.selectedChartType
          },
          series: [{
            type: this.selectedChartType,
            name: 'Nombre d\'échantillons',
            data: counts
          }]
        });
      } else {
        this.lineChart = new Chart({
          chart: {
            type: this.selectedChartType
          },
          title: {
            text: `Nombre d'échantillons créés (${this.selectedDuration})`
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: dates,
            title: {
              text: 'Dates'
            }
          },
          yAxis: {
            title: {
              text: 'Nombre d\'échantillons'
            },
            min: 0,
            tickInterval: 1,
            labels: {
              formatter: function () {
                return String(this.value);
              }
            }
          },
          series: [{
            type: this.selectedChartType,
            name: 'Nombre d\'échantillons',
            data: counts
          }]
        });
      }

      // Maintenant, on récupère les données sur les statuts des échantillons
      this.loadStatusData();
      
    }, error => {
      console.error('Erreur lors de la récupération des données du backend:', error);
    });
  }
  loadStatusData(): void {
    this.sampleService.getSampleStatusCount().subscribe(statusData => {
      console.log('✅ Réponse brute du backend:', statusData); 
    
      if (typeof statusData !== 'object' || Array.isArray(statusData)) {
        console.error('❌ Données invalides reçues du backend:', statusData);
        return;
      }
    
      // Initialisation des compteurs
      const statusCount = {
        'Avec OT': statusData['Avec OT'] || 0,
        'Sans OT': statusData['Sans OT'] || 0
      };
    
      console.log('🔍 Statut comptabilisé:', statusCount); 
    
      // Calcul du total pour le pourcentage
      const total = statusCount['Avec OT'] + statusCount['Sans OT'];
    
      // Mise à jour du graphique pie
      if (this.pieChart) {
        this.pieChart.ref?.update({
          series: [{
            type: 'pie',
            data: [
              {
                name: 'Avec OT',
                y: total > 0 ? (statusCount['Avec OT'] / total) * 100 : 0,
                color: 'rgba(0, 128, 255, 0.7)'
              },
              {
                name: 'Sans OT',
                y: total > 0 ? (statusCount['Sans OT'] / total) * 100 : 0,
                color: 'rgba(255, 99, 132, 0.7)'
              }
            ]
          }]
        });
      } else {
        this.pieChart = new Chart({
          chart: {
            type: 'pie',
            plotShadow: false,
          },
          credits: {
            enabled: false,
          },
          title: {
            text: 'Répartition des échantillons (Avec/Sans OT)'
          },
          series: [{
            type: 'pie',
            data: [
              {
                name: 'Avec OT',
                y: total > 0 ? (statusCount['Avec OT'] / total) * 100 : 0,
                color: 'rgba(0, 128, 255, 0.7)'
              },
              {
                name: 'Sans OT',
                y: total > 0 ? (statusCount['Sans OT'] / total) * 100 : 0,
                color: 'rgba(255, 99, 132, 0.7)'
              }
            ]
          }]
        });
      }
    }, error => {
      console.error('❌ Erreur lors de la récupération des statuts:', error);
    });    
  }
  
  
  
  handleChartType(type: 'area' | 'bar' | 'column' | 'spline'): void {
    this.selectedChartType = type;
    this.loadSampleData(this.selectedDuration);
  }

  handleDuration(duration: string): void {
    this.selectedDuration = duration;
    this.loadSampleData(this.selectedDuration);
  }
}
